"use client";

import { useTranslations } from "use-intl";

import { MusicIcon } from "@/components/appIcons";
import { FilterSelect, type FilterOption } from "@/components/ui/filter-select";

interface GenreFilterSelectProps {
  options: FilterOption[];
  value: string | null;
  onChange: (value: string | null) => void;
}

export function GenreFilterSelect({ options, value, onChange }: GenreFilterSelectProps) {
  const t = useTranslations("shared.releaseFilters");

  return (
    <FilterSelect
      icon={MusicIcon}
      placeholder={t("genre")}
      options={options}
      value={value}
      onChange={onChange}
      searchable
      searchPlaceholder={t("searchGenre")}
    />
  );
}
